<template>
    <div @click="adjustResult" class="adjust_result-btn"
         :class="{failed : failed, loading: loading, loaded : loaded, disabled : disabled}">
        <span>{{translate("adjust")}}</span>
        <div class="loading_spinner-wrapper">
            <transition name="fade" mode="out-in">
                <div :key="loading" v-if="loading" class="sk-fading-circle">
                    <div class="sk-circle1 sk-circle"></div>
                    <div class="sk-circle2 sk-circle"></div>
                    <div class="sk-circle3 sk-circle"></div>
                    <div class="sk-circle4 sk-circle"></div>
                    <div class="sk-circle5 sk-circle"></div>
                    <div class="sk-circle6 sk-circle"></div>
                    <div class="sk-circle7 sk-circle"></div>
                    <div class="sk-circle8 sk-circle"></div>
                    <div class="sk-circle9 sk-circle"></div>
                    <div class="sk-circle10 sk-circle"></div>
                    <div class="sk-circle11 sk-circle"></div>
                    <div class="sk-circle12 sk-circle"></div>
                </div>
                <span :key="loaded" v-if="loaded || disabled" class="icon-thin_ok"/>
                <img :key="failed" v-if="failed" src="/gfx/svg/failed.svg" alt="failed_icon"/>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdjustResultBtn",
        data() {
            return {
                loading: false,
                loaded: false,
                failed: false,
            }
        },
        methods: {
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            logTime(time) {
                let form = new FormData();
                form.append('time', time);

                let multiple = this.$store.state.selectedSecondStepElement.multiple_fans == 1;
                form.append('multiple', multiple);

                form.append('choice_number', this.$store.state.numberOfChoices);

                this.$apiController.logChoiceTime(form);
            },

            async adjustResult() {
                let _this = this;
                this.$root.$emit('disabledCadTable');
                this.$root.$emit('order', this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParameters.pressure.options[0].elements) + '_efficiency');

                this.$store.state.lastCalculationSelectedPressureType = this.getPressureType();

                this.$store.state.fourthStepParametersSelected = JSON.parse(JSON.stringify(this.$store.state.fourthStepParameters));

                // NVS-188 Kasowanie informacji o wczytanej ofercie
                this.$store.commit('resetLoadedOffer');

                if (this.disabled || this.loading || this.loaded)
                    return;

                this.$store.state.calculatingPercentage = 0;

                this.loading = true;

                this.$root.$emit('calculatingInProces', [true]);
                this.$root.$emit('disabledParamAside');

                // NVS-92 zapis temperatury z doboru
                this.$store.state.fourthStepParameters.temperature.oryginal = this.$store.state.fourthStepParameters.temperature.value;

                let startTime = new Date().getTime();

                _this.$calculator.calculate(this.$store).then(() => {
                    _this.loading = false;
                    this.$root.$emit('calculatingInProces', [false]);
                    this.$store.state.calculatingPercentage = 0;

                    _this.$store.commit({
                        type: 'filterAllColumn',
                    });

                    this.$store.state.numberOfChoices++;

                    let endTime = new Date().getTime();
                    let diff = endTime - startTime;

                    if (this.isLogged) {
                        this.logTime(diff);
                    }

                    this.$nextTick(() => {
                        if (_this.$store.state.fansTableData.FanTableRef.allFilteredData.length > 0) {
                            _this.$store.commit({
                                type: 'selectFanRowAsActiveInFansTable',
                                fan_id: _this.$store.state.fansTableData.FanTableRef.allFilteredData[0].id
                            });

                        }

                        _this.manageSelectedPartsOfGraphs();
                        _this.showSuccesful();
                    });
                });
            },

          getPressureType() {
            for (let optionId in this.$store.state.fourthStepParametersSelected.pressure.options) {
              let option = this.$store.state.fourthStepParametersSelected.pressure.options[optionId];
              if (option.type && option.type == "radio") {
                for (let elementId in option.elements) {
                  let element = option.elements[elementId];

                  if (element.active)
                    return element.value;
                }
              }
            }
          },

            manageSelectedPartsOfGraphs() {
                let pressureType = this.$fanObjParamsManager.getPressureType(this.$store);
                pressureType = pressureType.charAt(0).toUpperCase() + pressureType.slice(1);

                for (let axis in this.$store.state.partsOfTheGraph.mainAxisParams) {
                    if (axis == "pressure") {
                        this.$store.state.partsOfTheGraph.mainAxisParams[axis].active = true;
                    }

                    for (let specificParts in this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts) {
                        if (specificParts == pressureType + "Pressure" || specificParts == "DynamicPressure" ||
                            (specificParts == "PowerOnShaftWithMaterial" && this.$store.state.fourthStepParametersSelected.material_amount.value > 0) ||
                            (specificParts == "PowerOnShaft" && this.$store.state.fourthStepParametersSelected.material_amount.value == 0)) {
                            this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts[specificParts].active = true;
                        } else {
                            this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts[specificParts].active = false;
                        }
                    }
                }

                this.$store.commit({
                    type: 'clearMainAxisParams'
                });

                this.$store.commit({
                    type: 'selectMainAxisParam',
                    param_id: 'pressure'
                });

                this.$store.state.partsOfTheGraphChanged++;
            },

            clearStatus() {
                this.loading = false;
                this.loaded = false;
                this.failed = false;
                // this.disabled = false;
            },

            showSuccesful() {
                this.loaded = true;
                let _this = this;

                setTimeout(function () {
                    _this.loaded = false;
                    _this.$root.$emit('enabledParamAside');
                    _this.$store.commit({
                        type: 'toggleAdjustResultBtn',
                        disabled: true
                    })

                }, 1000);
            },

            showError() {
                this.failed = true;
                let _this = this;

                setTimeout(function () {
                    _this.failed = false;
                }, 3000);
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },
        computed: {

            isLogged() {
                return this.$store.getters.getIfUserLogged;
            },

            disabled() {
                return this.$store.state.isAdjustResultDisabled;
            }
        },
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
